// extracted by mini-css-extract-plugin
export default {"card_image":"InputUpload_card_image__CH0f+","card-mage":"InputUpload_card-mage__kaKLM"};